<div class="row">
  <div class="col d-flex pr-0" [class.flex-row-reverse]="options.reverse" [class.justify-content-end]="options.reverse">
    <mdb-icon *ngIf="options.icon" fas size="sm" [icon]="options.icon" [class]="options.reverse ? 'ml-1 ' : 'mr-1 ' + options.iconColor ?? ''"></mdb-icon>
    <p class="{{ color }}">{{ label }}</p>
  </div>
  <div class="col-auto">
    <p *ngIf="!suffix" class="{{ color }}">{{ value }}</p>
    <p *ngIf="suffix" class="{{ color }}">{{ value }} {{ suffix }}</p>
  </div>
</div>
